// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__rM5Fa","additionalInfo":"AgreementModal_additionalInfo__pH1n0"};